import React from "react";
import PropTypes from "prop-types";
import { Form } from "react-bootstrap";
import "./InputField.scss";

function InputField(props) {
  return (
    <div className="input-field">
      <Form.Label htmlFor={props.id}>{props.label}</Form.Label>
      <Form.Control
        type={props.type}
        id={props.id}
        value={props.value}
        onBlur={props.onBlur}
        onChange={props.onChange}
      />
    </div>
  );
}

InputField.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default InputField;
